const ConsoleStyles = {
    important: "background: #000; border-radius: 10px; padding: 10px; color: #fff; font-size: 16px"
}

export default ConsoleStyles;